import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Home, Briefcase, MessageCircle, User, Sparkles } from 'lucide-react';

const MobileBottomNav = () => {
    const { isAuthenticated, user } = useAuth();
    const { pathname } = useLocation();

    const dashboardPath = user?.role === 'EMPLOYER' ? '/employer/dashboard' : '/student/dashboard';

    const items = [
        { icon: Home,          label: 'Home',     href: '/' },
        { icon: Briefcase,     label: 'Jobs',     href: '/jobs' },
        { icon: Sparkles,      label: 'AI Tools', href: isAuthenticated ? '/ai/resume-builder' : '/login' },
        { icon: MessageCircle, label: 'Messages', href: isAuthenticated ? (user?.role === 'EMPLOYER' ? '/employer/messages' : '/student/messages') : '/login' },
        { icon: User,          label: isAuthenticated ? 'Profile' : 'Sign In', href: isAuthenticated ? dashboardPath : '/login' },
    ];

    // Don't render on auth pages or admin
    const hidden = ['/login', '/signup', '/forgot-password', '/verify-email', '/add-phone'].some(p => pathname.startsWith(p))
        || pathname.startsWith('/admin');
    if (hidden) return null;

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-hw-slate-200 shadow-lg safe-area-inset-bottom">
            <div className="flex items-center justify-around h-16 px-2">
                {items.map(({ icon: Icon, label, href }) => {
                    const active = href === '/' ? pathname === '/' : pathname.startsWith(href);
                    return (
                        <Link
                            key={label}
                            to={href}
                            className={`flex flex-col items-center justify-center gap-0.5 px-3 py-1 rounded-xl transition-colors ${
                                active ? 'text-hw-indigo-600' : 'text-hw-slate-400'
                            }`}
                        >
                            {active && (
                                <span className="absolute -top-0 h-0.5 w-8 bg-hw-indigo-600 rounded-full" />
                            )}
                            <Icon className={`h-5 w-5 ${active ? 'stroke-[2.5]' : 'stroke-2'}`} />
                            <span className={`text-[10px] font-semibold ${active ? 'text-hw-indigo-600' : 'text-hw-slate-400'}`}>{label}</span>
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
};

export default MobileBottomNav;
